import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="otp-challenge"
export default class extends Controller {
  static targets = ["otpInput", "input"];

  declare otpInputTarget: HTMLInputElement;
  declare hasOtpInputTarget: boolean;
  declare inputTargets: HTMLInputElement[];
  declare hasInputTarget: boolean;

  connect() {
    console.log("connect");
    console.log(this.hasInputTarget);
    console.log(this.hasOtpInputTarget);
    if (this.hasInputTarget) this.inputTargets.find((i) => i.dataset.index == "0")?.focus();
  }

  sanitize(event) {
    let value = event.target.value;
    let currentValue = "";
    if (value.length == 1) {
      if (value.match(/^[0-9]{1}$/)) {
        let nextIndex = parseInt(event.target.dataset.index) + 1;
        this.inputTargets.find((i) => i.dataset.index == nextIndex.toString())?.focus();
        if (!this.hasInputTarget) return;

        this.inputTargets.forEach((i) => (currentValue += i.value));
        if (this.hasOtpInputTarget) this.otpInputTarget.value = currentValue;
      }
    } else {
      event.target.value = "";
    }
  }

  back(event) {
    if (event.key != "Backspace" || event.target.value != "" || !this.hasInputTarget) return;

    let prevIndex = parseInt(event.target.dataset.index) - 1;
    this.inputTargets.find((i) => i.dataset.index == prevIndex.toString())?.focus();
  }

  paste(event) {
    if (!this.hasInputTarget) return;

    event.preventDefault();
    let pasteData = event.clipboardData.getData("text/plain").trim();
    if (!pasteData.match(/^[0-9]{6}$/)) return;

    this.inputTargets.forEach((i) => (i.value = pasteData[parseInt(i.dataset.index)] || ""));
    if (this.hasOtpInputTarget) this.otpInputTarget.value = pasteData;
    console.log(this.otpInputTarget.value);
  }
}
